/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return window.wetheme.$.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: window.wetheme.$(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};

ShopifyAPI.addItemFromJSON = function(data, callback, errorCallback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', data);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, data);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, data);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, data]);
      callback()
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log(textStatus)
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
}

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  window.wetheme.$(document.body).trigger('beforeGetCart.ajaxCart');
  window.wetheme.$.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    window.wetheme.$(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = window.wetheme.$(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  window.wetheme.$.ajax(params);
};


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // $addToCart is the button el we need

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled and use-ajax data is undefined or true
    if (!settings.disableAjaxCart && $addToCart.length && $addToCart.data('use-ajax') !== false) {
      formOverride($formContainer);
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $('.site-header__cart-indicator').removeClass('hide');

      if (cart.item_count === 0) {
        $('.site-header__cart-indicator').addClass('hide');
      }
    }
  };

  formOverride = function ($form) {
    $form.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  formOverride($('.js-gcForm'))

  $('.js-addSubscription').on('click', function(event) {
    event.preventDefault()
    var variantData = JSON.parse($('[data-variant-map').html())

    var data = {
      id: variantData[$formContainer.find('select.js-variantId').val()],
      quantity: 1,
      properties: {
        subscription: true,
        shipping_interval_frequency: $(this).attr('data-interval'),
        shipping_interval_unit_type: $(this).attr('data-unit'),
        subscription_id: $(this).attr('data-subId'),
        compare_at_price: $(this).attr('data-cap'),
        url: $(this).attr('data-url')
      }
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(line_item) {
        itemAddedCallback(line_item)
      },
      error: function(error) {
        console.log(error)
      }
    })
  })

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);

    $('.js-cart-count').text(cart.item_count)
    if(cart.item_count > 0) {
      $('.js-cart-count').show()
    } else {
      $('.js-cart-count').hide()
    }
  };
  

  var onUpsellAdded = function(el) {

    console.log(el)

    var data = {
      id: el.getAttribute('data-id'),
      quantity: 1,
      properties: JSON.parse(el.getAttribute('data-properties'))
    }

    // This adds to cart, now we just need the cart to update straight away
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(line_item) {
        $('.ajaxcart__upsells').remove()
        itemAddedCallback(line_item)
      },
    })
  }

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  var upsellHtml = function(item, upsell) {  
    var id;
    var properties = {};
    var upsellVarTitle;
    var detailsStyle;

    if(upsell.insole) {
      var variantTitle = item.variation + ' / ' + item.name.replace('The ', '');
      upsell.variants.forEach(function(variant) {
        if(variant.title == variantTitle) {
          id = variant.id;
          upsellVarTitle = variant.title;
        }
      })
    } else {
      id = upsell.variants[0].id;
      upsellVarTitle = upsell.variants[0].title;
    }

    if(upsell.subscription) {
      Object.keys(upsell.subscription_variants).forEach(function(key) {
        if(key == id) {
          id = Number(upsell.subscription_variants[key])
        }
      })

      properties.shipping_interval_frequency = Number(upsell.shipping_interval_frequency);
      properties.shipping_interval_unit_type = upsell.shipping_interval_unit_type;
      properties.original = upsell.handle;
    }

    if(upsell.details !== '') {
      detailsStyle = 'block'
    } else {
      detailsStyle = 'none'
    }
    
    var html = [
      '<div class="ajaxcart__upsells">',
        '<div class="upsell__card">',
          '<div class="shopify-product-form js-upsell-form upsell__inner cart-item__inner">',
            '<a class="cart-item__image" href="' + upsell.url + '">',
              '<img class="lazyload" src="' + upsell.image + '">',
            '</a>',
            '<div class="upsell__content cart-item__content">',
              '<a class="cart-item__title fw-600" href="' + upsell.url + '">' + upsell.title + '</a>',
              '<p class="cart-item__variant">' + upsellVarTitle + '</p>',
              '<a href="/" class="upsell__details-toggle js-upsell-details-toggle" style="display:' + detailsStyle + ';">View Details</a>',
            '</div>',
            '<p class="upsell__price cart-item__price">' + upsell.price +'</p>',
            "<a class='upsell__atc-button fw-600 js-upsell-atc' data-id='" + id + "' data-properties='" + JSON.stringify(properties) + "'>Add to Cart <span class='atc-icon-plus'></span></a>",
          '</div>',
          '<div class="upsell__details js-upsell-details">' + htmlDecode(upsell.details) + '</div>',
        '</div>',
      '</div>'
    ].join('')

    return html
  }


  // Add cart html here
  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      var defaultUpsell = jQuery.parseJSON(document.querySelector('input#shop-upsell-data').value)
      
      $cartContainer
        .append('<p class="empty-cart fw-600">' + "BOOOOOOO! There\u0026#39;s nothing in your cart" + '</p> <div class="drawer__close shop-now js-drawer-close"><a href="" class="empty-cart__close fw-600 ttu" >Shop Now</a></div>')
      $cartContainer.append(upsellHtml(null, defaultUpsell))

      $('.js-upsell-atc').on('click', function(event){
        event.preventDefault()
        onUpsellAdded(event.currentTarget)
      })

      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);


    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _300x, and re-add extension
       *     - Create server relative link
       *     - Create responsive variant (`_{width}x` as size)
       *   - A hard-coded url of no-image
      */
      var prodImgResponsive = null
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_300x$1").replace('http:', '');
        var prodImgResponsive = cartItem.image.replace(/(\.[^.]*)$/, "_{width}$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var properties = {};

      if(cartItem.properties) {
        Object.keys(cartItem.properties).forEach(function (key) {
          if (key[0] !== '_') {
            properties[key] = cartItem.properties[key];
          }
        });
      }

      let optionName

      if (cartItem.variant_options.length >= 3) {
        optionName = '';
      } else if (cartItem.options_with_values[0].name !== 'Title') {
        optionName = cartItem.options_with_values[0].name + ':'
      }  

      console.log(cartItem)

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        handle: cartItem.handle,
        img: prodImg,
        imgResponsive: prodImgResponsive,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        option: optionName,
        properties: properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney((cartItem.original_line_price), settings.moneyFormat),
        discountsApplied: cartItem.original_line_price > 0 && cartItem.final_line_price < cartItem.original_line_price,
        discountAllocations: cartItem.line_level_discount_allocations.map(function (allocation) {
          allocation.money = Shopify.formatMoney(allocation.amount, settings.moneyFormat);
          return allocation;
        }),
        unitPriceMeasurement: cartItem.unit_price_measurement,
        unitPrice: cartItem.unit_price? Shopify.formatMoney(cartItem.unit_price, settings.moneyFormat) : null,
        unitRefValue: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_value : null,
        unitRefUnit: cartItem.unit_price_measurement ? cartItem.unit_price_measurement.reference_unit : null,
        original: properties.original || cartItem.handle,
      };
 
      items.push(item);
    });

    // Need to loop over the items to get the upsell here
    // Then add the upsell to the data object below
    // Then render it out in the ajax-cart-template.liquid

    var upsellProduct = function(items) {
      var handles = [];
      var url = '/pages/upsell-api?products=';

      items.forEach(function(item) {
        if(!handles.includes(item.handle)) {
          handles.push(item.handle);
        }
      })

      handles.forEach(function(handle, index) {
        if(index == 0) {
          url = url + handle;
        } else {
          url = url + '&' + handle;
        }
      })

      $.ajax(url).done(function (response) {
        
        var upsells = JSON.parse(response).upsells;
        
        $.each(upsells, function(index, upsell) {
          var isInCart = items.find(function(item) { return item.original == upsell.handle })
          
          if(upsell.available && !isInCart && $('.ajaxcart__upsells').length < 1) {
            var baseHandle = upsell.base_product;
            var baseProduct;

            items.forEach(function(item) {
              if(item.handle == baseHandle) {
                baseProduct = item;
              }
            })

            $cartContainer.append(upsellHtml(baseProduct, upsell));

            $('.js-upsell-atc').on('click', function(event){
              event.preventDefault()
              onUpsellAdded(event.currentTarget)
            })

            $('.js-upsell-details-toggle').on('click', function(event) {
              event.preventDefault()
              $('.js-upsell-details').slideToggle('fast')
            })

            return false;
          } else {
            return true;
          }
        })
      });
    }

    
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartOriginal: cart.original_total_price > cart.total_price ? Shopify.formatMoney(cart.original_total_price, settings.moneyFormat) : null,
      discountApplications: cart.cart_level_discount_applications.map(function (application) {
        application.money = Shopify.formatMoney(application.total_allocated_amount, settings.moneyFormat);
        return application;
      })
    }

    // Append html here?
    $cartContainer.append(template(data));
    upsellProduct(data.items)

    var subscription = false;
    data.items.forEach(function(item) {
      if('shipping_interval_frequency' in item.properties) {
        subscription = true;
      }
    })

    var $container = $('.js-cartButton')
    var $button
    if(subscription) {
      $button = $('<button class="cart__checkout js-subscriptionCheckout"></button>')
      $button.attr('data-domain', $container.attr('data-domain'))
    } else {
      $button = $('<button class="cart__checkout js-shopifyCheckout"></button>')
      $button = $('<button type="submit" name="checkout" class="cart__checkout js-shopifyCheckout"></button>')
    }
    $button.text($container.attr('data-text'))
    $container.append($button)

    $('.js-subscriptionCheckout').on('click', function(event) {
      event.preventDefault()
      let url = 'https://shopifysubscriptions.com/r/checkout?myshopify_domain=' + $(this).attr('data-domain') + '&cart_token=' + cart.token
      window.location = url
    })

    // $('.js-shopifyCheckout').on('click', function(event) {
    //   event.preventDefault()
    //   data.items.forEach(item => {
    //     if(item.properties.cartUpsell) {
    //       delete item.properties.cartUpsell
    //     }
    //   })
    //   console.log(data.items)
    //   $('.js-shopifyCheckout').attr('name', 'checkout')
    //   $('.js-shopifyCheckout').attr('type', 'submit')
    // })

    // console.log(data)
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    // $('.js-upsell-details-toggle').on('click', function(event) {
    //   event.preventDefault()
    //   $('.js-upsell-details').slideToggle('fast')
    // })
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
      if (isUpdating) {
        return;
      }

      var 
        $el = $(this),
        line = $el.data('line'),
        oldQuantity = $el.data('qty'),
        qty = oldQuantity - 1
      ;

      // Remove all items of this type from the cart
      if (line) {
        updateQuantity(line, qty);
      }

    });


    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)

    $('.js-cart-count').text(cart.item_count)
    if(cart.item_count > 0) {
      $('.js-cart-count').show()
    } else {
      $('.js-cart-count').hide()
    }
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    itemAddedCallback: itemAddedCallback,
    itemErrorCallback: itemErrorCallback
  };

  return module;

}(ajaxCart || {}, window.wetheme.$));